import request from '@/request'
import store from '@/store'
import CONSTANTS from '@/constants'

const state = {
    template: null
}

const mutations = {
    SET_PROFILE_TEMPLATE: (state, data) => {
        state.template = data
    }
}

const actions = {
    uploadFileImages({ commit }, data) {
        return new Promise((resolve, reject) => {
            request({
                url: '/user/images/update',
                method: 'post',
                data: data
            }).then(response => {
                resolve(response.data)
            }).catch(error => {
                reject(error)
            })
        })
    },
    updateImageStatus({ commit }, data) {
        return new Promise((resolve, reject) => {
            request({
                url: '/user/update_image_status',
                method: 'post',
                data: data
            }).then(response => {
                resolve(response.data)
            }).catch(error => {
                reject(error)
            })
        })
    },
    deleteAvatar({ commit }, data) {
        return new Promise((resolve, reject) => {
            request({
                url: '/user/delete_avatar',
                method: 'post',
                data: data
            }).then(response => {
                resolve(response.data)
            }).catch(error => {
                reject(error)
            })
        })
    },
    getProfileTemplate({ commit }, params) {
        return new Promise((resolve, reject) => {
            request({
                url: '/user/get_profile_template',
                method: 'get',
                params: params
            }).then(response => {
                commit('SET_PROFILE_TEMPLATE', response.data)
                resolve(response.data)
            }).catch(error => {
                reject(error)
            })
        })
    },
    getNotices({ commit }, params) {
        return new Promise((resolve, reject) => {
            request({
                url: '/discuss/post/notice_list',
                method: 'get',
                params: params
            }).then(response => {
                resolve(response.data)
            }).catch(error => {
                reject(error)
            })
        })
    },
    getNoticeDetail({ commit }, params) {
        return new Promise((resolve, reject) => {
            request({
                url: '/discuss/notice_user_detail',
                method: 'get',
                params: params
            }).then(response => {
                resolve(response.data)
            }).catch(error => {
                reject(error)
            })
        })
    },

    getCampaignList({ commit }, params) {
        return new Promise((resolve, reject) => {
            request({
                url: '/campaign/lists',
                method: 'get',
                params: params
            }).then(response => {
                resolve(response.data)
            }).catch(error => {
                reject(error)
            })
        })
    },
    getFavoriteList({ commit }, params) {
        return new Promise((resolve, reject) => {
            request({
                url: '/favorites/index/lists',
                method: 'get',
                params: params
            }).then(response => {
                resolve(response.data)
            }).catch(error => {
                reject(error)
            })
        })
    },
    sendLikeMessage({ commit }, params) {
        let pointSetting = null
        store.dispatch('user/getPointFee', {
            token: store.getters.defaultToken
        }).then(data => {
            pointSetting = data
            let sub_point_look_at_me = pointSetting.result.filter(item => {
                return item.slug === 'message_with_like' && parseInt(item.type) === CONSTANTS.SUB_ACTION_POINT
            })
            if (sub_point_look_at_me[0] && parseInt(pointSetting.balance) >= parseInt(sub_point_look_at_me[0].point)) {
                return new Promise((resolve, reject) => {
                    request({
                        url: '/user/like_message',
                        method: 'post',
                        data: params
                    }).then(response => {
                        resolve(response.data)
                    }).catch(error => {
                        reject(error)
                    })
                })
            } else {
                window.location = "/profile/buy-point"
            }
        }).catch(err => {
            console.log(err)
        })

    },

    getFootprints({ commit }, params) {
        return new Promise((resolve, reject) => {
            request({
                url: 'footprint/index/list',
                method: 'get',
                params: params
            }).then(response => {
                resolve(response.data)
            }).catch(error => {
                reject(error)
            })
        })
    },
    veryUpload({ commit }, data) {
        return new Promise((resolve, reject) => {
            request({
                url: 'user/verify_upload ',
                method: 'post',
                data
            }).then(response => {
                resolve(response.data)
            }).catch(error => {
                reject(error)
            })
        })
    },

    blockUser({ commit }, data) {
        return new Promise((resolve, reject) => {
            request({
                url: 'user/lock',
                method: 'post',
                data
            }).then(response => {
                resolve(response.data)
            }).catch(error => {
                reject(error)
            })
        })
    },

    getMuteMessages({ commit }, params) {
        return new Promise((resolve, reject) => {
            request({
                url: 'user/getMuteList',
                method: 'get',
                params: params
            }).then(response => {
                resolve(response.data)
            }).catch(error => {
                reject(error)
            })
        })
    },
    muteMessage({ commit }, data) {
        return new Promise((resolve, reject) => {
            request({
                url: 'user/muteUser',
                method: 'post',
                data
            }).then(response => {
                resolve(response.data)
            }).catch(error => {
                reject(error)
            })
        })
    },
    getPointSettingList({ commit }, params) {
        return new Promise((resolve, reject) => {
            request({
                url: 'point/point_setting_list',
                method: 'get',
                params: params
            }).then(response => {
                resolve(response.data)
            }).catch(error => {
                reject(error)
            })
        })
    },
    //
    getPointHistory({ commit }, params) {
        return new Promise((resolve, reject) => {
            request({
                url: 'point/history',
                method: 'get',
                params: params
            }).then(response => {
                resolve(response.data)
            }).catch(error => {
                reject(error)
            })
        })
    },

    getMemo({ commit }, params) {
        return new Promise((resolve, reject) => {
            request({
                url: 'user/get_list_memo',
                method: 'get',
                params: params
            }).then(response => {
                resolve(response.data)
            }).catch(error => {
                reject(error)
            })
        })
    },

    createMemo({ commit }, data) {
        return new Promise((resolve, reject) => {
            request({
                url: 'user/memo',
                method: 'post',
                data
            }).then(response => {
                resolve(response.data)
            }).catch(error => {
                reject(error)
            })
        })
    },
    deleteMemo({ commit }, data) {
        return new Promise((resolve, reject) => {
            request({
                url: 'user/delete_memo',
                method: 'post',
                data
            }).then(response => {
                resolve(response.data)
            }).catch(error => {
                reject(error)
            })
        })
    },
    getCampaignDetail({ commit }, params) {
        return new Promise((resolve, reject) => {
            request({
                url: 'campaign/get_detail',
                method: 'get',
                params
            }).then(response => {
                resolve(response.data)
            }).catch(error => {
                reject(error)
            })
        })


    },
    readAllNotices({ commit }, params) {
        return new Promise((resolve, reject) => {
            request({
                url: '/discuss/read_all_notice',
                method: 'get',
                params: params
            }).then(response => {
                resolve(response.data)
            }).catch(error => {
                reject(error)
            })
        })
    },

}

export default {
    namespaced: true,
    state,
    mutations,
    actions
}